import React from 'react';

export const highlightText = (text: string, searchQuery: string): React.ReactNode => {
  const trimmedQuery = searchQuery.trim();
  if (!trimmedQuery) return text;
  const query = trimmedQuery.toLowerCase();
  const queryWithoutCommas = query.replace(/,/g, '');
  const queryHasSymbols = query.includes('$') || query.includes('€') || query.includes('%');
  if (queryHasSymbols) {
    const exactMatchIndex = text.toLowerCase().indexOf(query);
    if (exactMatchIndex !== -1) {
      const before = text.substring(0, exactMatchIndex);
      const match = text.substring(exactMatchIndex, exactMatchIndex + query.length);
      const after = text.substring(exactMatchIndex + query.length);
      return (
        <>
          {before}
          <mark className="bg-yellow-200">{match}</mark>
          {after}
        </>
      );
    }
    const textWithoutCommas = text.replace(/,/g, '');
    const matchIndex = textWithoutCommas.toLowerCase().indexOf(queryWithoutCommas);
    if (matchIndex !== -1) {
      let originalIndex = 0;
      let strippedIndex = 0;
      while (strippedIndex < matchIndex && originalIndex < text.length) {
        if (text[originalIndex] !== ',') {
          strippedIndex++;
        }
        originalIndex++;
      }
      let endIndex = originalIndex;
      let matchedLength = 0;
      while (matchedLength < queryWithoutCommas.length && endIndex < text.length) {
        if (text[endIndex] !== ',') {
          matchedLength++;
        }
        endIndex++;
      }
      const before = text.substring(0, originalIndex);
      const match = text.substring(originalIndex, endIndex);
      const after = text.substring(endIndex);
      return (
        <>
          {before}
          <mark className="bg-yellow-200">{match}</mark>
          {after}
        </>
      );
    }
  } else {
    const textWithoutCommas = text.replace(/,/g, '');
    const textWithoutSymbols = textWithoutCommas.replace(/[$€%]/g, '');
    const matchIndex = textWithoutSymbols.toLowerCase().indexOf(queryWithoutCommas);
    if (matchIndex !== -1) {
      let originalIndex = 0;
      let strippedIndex = 0;
      while (strippedIndex < matchIndex && originalIndex < text.length) {
        if (text[originalIndex] !== ',' && text[originalIndex] !== '$' && text[originalIndex] !== '€' && text[originalIndex] !== '%') {
          strippedIndex++;
        }
        originalIndex++;
      }
      while (originalIndex < text.length && (text[originalIndex] === '$' || text[originalIndex] === '€')) {
        originalIndex++;
      }
      let endIndex = originalIndex;
      let matchedLength = 0;
      while (matchedLength < queryWithoutCommas.length && endIndex < text.length) {
        if (text[endIndex] !== ',' && text[endIndex] !== '$' && text[endIndex] !== '€' && text[endIndex] !== '%') {
          matchedLength++;
        }
        endIndex++;
      }
      while (endIndex > originalIndex && (text[endIndex - 1] === '%')) {
        endIndex--;
      }
      const before = text.substring(0, originalIndex);
      const match = text.substring(originalIndex, endIndex);
      const after = text.substring(endIndex);
      return (
        <>
          {before}
          <mark className="bg-yellow-200">{match}</mark>
          {after}
        </>
      );
    }
  }
  return text;
};

